import { ArrowTopLeftIcon } from "@radix-ui/react-icons";
import { RewindIcon } from "lucide-react";

import { IPlayground, usePlayground } from "@/components/Playground/playground-store";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { Button } from "@/components/ui/button";

const useExtraControls = (output: IPlayground, rewind: () => void) => {
  const playground = usePlayground();

  return (message_id: string) =>
    playground.latestOutput === output && !playground.latestOutput.isMessageCompleted(message_id)
      ? []
      : [
          <BasicTooltip
            key="popout"
            content={
              playground.isChat
                ? "Pop message into the chat"
                : "Pop in is only available for chat mode"
            }
          >
            <Button
              variant="default"
              onClick={() => playground.popIn(output, message_id)}
              disabled={!playground.isChat || playground.isAIPromptAssistantLoading}
              className="gap-2 whitespace-nowrap"
            >
              <ArrowTopLeftIcon className="h-4 w-4" />
              <span>Pop in</span>
            </Button>
          </BasicTooltip>,
          <BasicTooltip key="rewind" content="Review this playground state before rewinding">
            <Button
              variant="outline"
              onClick={rewind}
              disabled={playground.isAIPromptAssistantLoading}
              className="gap-2"
            >
              <RewindIcon className="h-4 w-4" />
              <span>Rewind</span>
            </Button>
          </BasicTooltip>,
        ];
};

export default useExtraControls;
